var _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBigFire(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 31,
    viewBox: "0 0 22 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.9538 19.8259C21.7089 25.8476 16.8918 30.6526 10.9828 30.6526C4.91715 30.6526 7.70963e-06 25.4199 7.70963e-06 19.3451C7.70963e-06 18.5331 -0.0141298 16.9103 1.16839 14.1725C1.87608 12.534 2.31995 11.5046 2.57045 10.5637C2.70809 10.0466 2.97576 9.22496 3.73883 10.5637C4.18878 11.3531 4.20619 12.4884 4.20619 12.4884C4.20619 12.4884 5.88024 11.1658 7.0103 8.63902C8.66695 4.93484 7.34516 2.72061 6.89347 1.18086C6.73714 0.648204 6.63899 -0.309086 7.71133 0.0982257C8.80401 0.513356 11.6927 2.59526 13.2027 4.78965C15.3578 7.92147 16.1237 10.9246 16.1237 10.9246C16.1237 10.9246 16.8137 10.0428 17.0584 9.12019C17.3347 8.07833 17.3388 7.04646 18.2267 8.15796C19.0711 9.21498 20.3251 11.2014 21.0309 13.0898C22.3125 16.5193 21.9538 19.8259 21.9538 19.8259Z",
    fill: "url(#paint0_linear_13068_13540)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9664 23.2982C18.7883 27.5519 15.2849 30.9461 10.9875 30.9461C6.57611 30.9461 3.00001 27.2497 3.00001 22.9586C3.00001 22.385 2.98972 21.2387 3.84974 19.3047C4.36442 18.1473 4.68724 17.4202 4.86942 16.7555C4.96952 16.3902 5.16419 15.8099 5.71915 16.7555C6.04638 17.3131 6.05904 18.1151 6.05904 18.1151C6.05904 18.1151 7.27654 17.1808 8.0984 15.3959C9.30324 12.7794 8.34194 11.2153 8.01343 10.1276C7.89974 9.75134 7.82836 9.07512 8.60824 9.36284C9.40291 9.65609 11.5038 11.1267 12.602 12.6768C14.1693 14.8891 14.7263 17.0104 14.7263 17.0104C14.7263 17.0104 15.2282 16.3876 15.4061 15.7358C15.6071 14.9999 15.61 14.271 16.2558 15.0561C16.8699 15.8028 17.7819 17.206 18.2952 18.54C19.2273 20.9625 18.9664 23.2982 18.9664 23.2982Z",
    fill: "url(#paint1_linear_13068_13540)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9876 30.946C7.93716 30.946 5.46436 28.4732 5.46436 25.4228C5.46436 23.5822 6.20609 22.4647 7.7498 20.9493C8.73821 19.979 9.66331 18.7872 10.0565 17.9757C10.1339 17.816 10.31 16.9835 10.9892 17.9582C11.3455 18.4694 11.9041 19.3785 12.2622 20.1544C12.8796 21.4922 13.027 22.7886 13.027 22.7886C13.027 22.7886 13.6321 22.4321 14.0467 21.514C14.1803 21.2181 14.4505 20.098 15.2059 21.218C15.7602 22.0398 16.5217 23.5175 16.5109 25.4228C16.5109 28.4732 14.038 30.946 10.9876 30.946Z",
    fill: "#FC9502"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0721 24.9128C11.8581 24.9128 11.8581 26.3683 12.8565 28.3118C13.5214 29.6058 12.5269 30.9459 11.0721 30.9459C9.61727 30.9459 8.86279 29.7666 8.86279 28.3118C8.86279 26.857 10.2861 24.9128 11.0721 24.9128Z",
    fill: "#FCE202"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13068_13540",
    x1: 10.9993,
    y1: 30.6752,
    x2: 10.9993,
    y2: 0.0231628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0D0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC9802"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_13068_13540",
    x1: 10.9995,
    y1: 30.962,
    x2: 10.9995,
    y2: 9.30982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4C0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC9502"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigFire);
export default __webpack_public_path__ + "static/media/big_fire.b844cdf18efbeb21e9d7bd4af297163b.svg";
export { ForwardRef as ReactComponent };